import React, { useState, useContext, useEffect } from 'react'
import DetailCardWithTable from '../../../dpe-usco/components/Details/DetailCardWithTable'
import { Button } from 'syngenta-react-components'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'
import { useParams } from 'react-router-dom'
import deleteIcon from '../../../assets/icons/close.svg'
import { deleteAssignment } from '../../../services/apiHelper'
import Warning from '../../../components/subComponents/Notifications/Warning'
import { AuthContext, GlobalContext } from '../../../services/context'
import { convertToTitleCase, convertToSentenceCase } from '../../../services/utils'
import HeaderFilter from '../../../components/subComponents/HeaderFilter'

export const LinkedContactsWidget = ({ data, handleModal, status, handleClose, customSort }) => {
  const { dispatch, trackEvent } = useContext(GlobalContext)
  const { company_id } = useParams()
  const [showWarning, setShowWarning] = useState(false)
  const [employeeName, setEmployeeName] = useState()
  const [employeeId, setEmployeeId] = useState()
  const { hasAccess } = useContext(AuthContext)
  const [isLoading, setIsLoading] = useState(false)

  const [contactsData, setContactsData] = useState()

  useEffect(() => {
    setContactsData(data)
  }, [data])

  const headerCell = (value, dataKey) => {
    const acendCallBack = () => {
      setContactsData(customSort(data, dataKey, 'asc'))
    }

    const decendCallBack = () => {
      setContactsData(customSort(data, dataKey, 'desc'))
    }

    return (
      <div key={value} className="cell df aic">
        <span>{value}</span>
        <HeaderFilter
          dataKey={dataKey}
          descend={() => decendCallBack()}
          ascend={() => acendCallBack()}
        />
      </div>
    )
  }
  
  const clickButton = (e, value) => {
    e.preventDefault()
    const correspondingEmployee = data.filter(employee => (employee.user_id === value))
    const correspondingEmployeeName = correspondingEmployee.map(employee => {
      const employeeName = `${employee.first_name} ${employee.last_name}`
      return employeeName
    })
    setEmployeeName(correspondingEmployeeName)
    setEmployeeId(value)
    setShowWarning(true)
    trackEvent('remove_linked_contact_clicked', correspondingEmployee[0])
  }

  const handleSubmit = async result => {
    setIsLoading(true)
    await deleteAssignment(employeeId, company_id)
    setShowWarning(false)
    handleClose(result)
    setIsLoading(false)
    trackEvent('remove_linked_contact_confirmed', {
      companyId: company_id,
      employeeId
    })
  }

  const handleDismissWarning = () => {
    setShowWarning(false)    
  }

  const employeesStructure = {
    headers: [
      {
        value: 'Name',
        format() {
          return headerCell(this.value, 'nameObj')
        }
      },
      {
        value: 'Role',
        format() {
          return headerCell(this.value, 'role')
        }
      },
      {
        value: 'Phone',
        format() {
          return headerCell(this.value, 'phone')
        }
      },
      {
        value: 'Email',
        format() {
          return headerCell(this.value, 'email')
        }
      },
      {
        value: '',
        format() {
          return <div key={this.value} className="cell df aic">
            <span>{this.value}</span>
          </div>
        }
      }
    ],
    dataKeys: [
      'nameObj', 'role', 'phone', 'email',
      'user_id'
    ],
    rowFormat: {
      nameObj: {
        format: nameObj => {
          return (
            <a
              className='c-blue-500 c-blue-700:h tdu:h'
              href={`/users/${nameObj.user_id}`}
              onClick={e => {
                e.preventDefault()
                const payload = {
                  company_id,
                  id: nameObj.user_id,
                  title: nameObj.name,
                  previous: 'Back'
                }
                trackEvent('linked_contact_link_clicked', {
                  company_id,
                  id: nameObj.user_id,
                  employeeName: nameObj.name
                })
                dispatch({ type: 'GO_TO_USER_DETAIL', payload })
              }}
            >
              {convertToTitleCase(nameObj.name)}
            </a>
            
          )
        }
      },
      user_id: {
        format: user_id => {
          return (
            <div className='w100% tar'>
              <button onClick={e =>{
                clickButton(e, user_id)}}  className='bgc-t bdnone curp fz15 fw700 pr20'>
                <img
                  alt='delete button icon'
                  src={deleteIcon}/>
              </button>
            </div>
          )
        }
      },
      role: {
        format: role => {
          return (
            <div>
              {convertToSentenceCase(role)}
            </div>
          )
        }
      }
    }
  }


  let widgetButton = null
  if(hasAccess(company_id, 'assign-internal-role') === 'SUCCESS'){
    widgetButton = <Button type='success' text='Invite user' clickHandler={handleModal}/>
  }

  return (
    <div className='mb25'>

      <DetailCardWithTable
        title={'Linked contacts'}
        structure={employeesStructure}
        data={contactsData}
        button={widgetButton}
        statusComponent={status? <TableStatus status={status} prompt='There are currently no employees associated with this company'/>  : null}
      />

      {showWarning
        ?
        <Warning
          warningMessage={isLoading ? `Deleting ${employeeName}, please wait...` : `You are about to delete ${employeeName} from this company's list. Are you sure?`}
          confirmationButtonText='Yes, delete'
          handleSubmit={() => handleSubmit('SUCCESS')}
          handleDismissWarning={handleDismissWarning}/>
        :
        null
      }
    </div>
  )
}

export default LinkedContactsWidget
